var requireLogin = require('widgets/requireLogin')
  , $ = require('jquery')
  , openAlert = require('mobile/ui/openAlert')
  , tmpl = require('./tmpl.handlebars')
  , ERROR_MSG = '网络发生了错误'

module.exports = requireLogin(function( gameCode ) {
  var url = '/game-vote.html';
  $.ajax({
    type: 'POST',
    url: url,
    dataType: 'json',
    data: {
      id : gameCode
    }
  })
  .done(function(data){
    if (data.result = 'success') {
      openAlert({
        html: tmpl()
      , content: '投票信息正在审核中，感谢您的热心参与!'
      })
    }else {
      openAlert({
        html: tmpl()
      , content: data.message
      })
    }
  })
  .fail(function(){ 
    openAlert({
      html: tmpl()
    , content: ERROR_MSG
    })
  })
}, 'vote')